// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WuvM","comment":"styles_comment__3XP78"};